// extracted by mini-css-extract-plugin
module.exports = {"infoWrapper":"ClientEmergencyInfo_infoWrapper__2IkRq","itemTitle":"ClientEmergencyInfo_itemTitle__3rKnV","itemText":"ClientEmergencyInfo_itemText__55FTR"};